module.exports = __webpack_public_path__ + "static/media/sample-logo.97839c89.png";